import { render } from "./OrderCustomerLink.vue?vue&type=template&id=999ad92e&scoped=true&ts=true&lang=pug"
import script from "./OrderCustomerLink.vue?vue&type=script&lang=ts"
export * from "./OrderCustomerLink.vue?vue&type=script&lang=ts"

import "./OrderCustomerLink.vue?vue&type=style&index=0&id=999ad92e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-999ad92e"]])

export default __exports__